import requests from "./customRequests/requests";
import {
  getFinDocSitConfig,
  mockAddFinDoc,
  mockAgreeFinDoc,
  mockCancelFinDoc,
  mockFinanceUploadFinDoc,
  mockGetFinDocDetail,
  mockGetFinDocMenus,
  mockMgrAgreeFinDoc,
  mockMgrRejectFinDoc,
  mockQueryArchivedFinDoc,
  mockQueryFinDoc,
  mockQueryFinDocLog,
  mockQueryIsAuditFinDoc,
  mockRejectFinDoc,
} from "./findoc.mock";

const isSitModeEnabled = () => getFinDocSitConfig().enabled;

export const getFinDocMenus = async () => {
  if (isSitModeEnabled()) {
    return mockGetFinDocMenus();
  }

  const resp = await requests().get("/FinDoc/GetMenus");
  return resp?.data;
};

export const queryFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockQueryFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/Query", payload);
  return resp?.data;
};

export const queryIsAuditFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockQueryIsAuditFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/Query/IsAudit", payload);
  return resp?.data;
};

export const queryArchivedFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockQueryArchivedFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/Query/Archived", payload);
  return resp?.data;
};

export const getFinDocDetail = async (findocNo) => {
  if (isSitModeEnabled()) {
    return mockGetFinDocDetail(findocNo);
  }

  const resp = await requests().get(`/FinDoc/GetDetail/${findocNo}`);
  return resp?.data;
};

export const queryFinDocLog = async (findocNo) => {
  if (isSitModeEnabled()) {
    return mockQueryFinDocLog(findocNo);
  }

  const resp = await requests().get(`/FinDoc/QueryLog/${findocNo}`);
  return resp?.data;
};

export const addFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockAddFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/AddFinDoc", payload);
  return resp?.data;
};

export const cancelFinDoc = async (findocNo) => {
  if (isSitModeEnabled()) {
    return mockCancelFinDoc(findocNo);
  }

  const resp = await requests().get(`/FinDoc/Cancel/${findocNo}`);
  return resp?.data;
};

export const agreeFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockAgreeFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/Agree", payload);
  return resp?.data;
};

export const rejectFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockRejectFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/Reject", payload);
  return resp?.data;
};

export const mgrAgreeFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockMgrAgreeFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/MgrAgree", payload);
  return resp?.data;
};

export const mgrRejectFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockMgrRejectFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/MgrReject", payload);
  return resp?.data;
};

export const financeUploadFinDoc = async (payload) => {
  if (isSitModeEnabled()) {
    return mockFinanceUploadFinDoc(payload);
  }

  const resp = await requests().post("/FinDoc/FinanceUpload", payload);
  return resp?.data;
};